import React, { useEffect, useState } from 'react'
import AdminTitle from '../../../common/AdminTitle/AdminTitle'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useParams } from 'react-router-dom'
import CollectionForm from './CollectionForm'
import { useShowByIdQuery, useUpdateCollectionMutation } from '../../../api/collection.api';

const CollectionEdit = () => {
  const params = useParams();
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const [collection, setCollection] = useState()

  const { data: collections, isLoading } = useShowByIdQuery(params.id)
  const [updateCollection] = useUpdateCollectionMutation()

  useEffect(() => {
    if (collections) {
      setCollection(collections?.result)
    }
  }, [collections])

  const submitEvent = async (data) => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("name", data.name);
      formData.append("description", data.description || "");  
      formData.append("status", data.status.value);  
      formData.append("category", data.category.value);

      if (data.image instanceof File) {
        formData.append("image", data.image);
      }
      if (data.video instanceof File) {
        formData.append("video", data.video);
      }

      await updateCollection({ id: params.id, payload: formData }).unwrap();

      toast.success("Collection Updated Successfully");
      navigate('/dashboard/collection')
    } catch (exception) {
      let errorMessage = "Error while updating collection";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='admin_margin_box'>
      <ToastContainer />
      <div className="admin_titles">
        <AdminTitle label1=" Collection List" label2="/Edit Collection" url="/dashboard/collection" />
        <div className='Dashboard_title'>
          <h1>Edit Collection</h1>
        </div>
      </div>

      <div className="banner_form">        
        <CollectionForm
          detail={
            collection
              ? {
                  name: collection.name,
                  description: collection.description,
                  status: {
                    label: collection.status === 'active' ? 'Active' : 'Inactive',
                    value: collection.status
                  },
                  category: {
                    label: collection.category === "image" ? "Image" : "Video",
                    value: collection.category,
                  },
                  image: collection.image || collection.desktopImage,
                  video: collection.video || collection.desktopVideo,
                }
              : null
          }          
          submitEvent={submitEvent}
          value='Update Collection'
          loading={loading}  
        />
      </div>
    </div>
  )
}

export default CollectionEdit